import {Button} from "@progress/kendo-react-buttons"
import {useInternationalization} from "@progress/kendo-react-intl"
import dayjs from "dayjs"
import {MDBCardBody, MDBCol, MDBRow} from "mdbreact"
import {dvsaToggleAddEditModal, setDsvaFeeSelectedId, setSelectedDvsaFee} from "../../containers/DvsaFees/dvsaFeesSlice"
import {RootState} from "../../rootReducer"
import {useAppDispatch, useAppSelector} from "../../store"
import {hasPermission} from "../Shared/permissionChecker"

const DvsaFeePricingBody = ({dvsaCard}: {dvsaCard: any}) => {
    const dispatch = useAppDispatch()
    const intl = useInternationalization()

    const formatPrice = (price: number) => intl.formatNumber(price, {style: "currency", minimumFractionDigits: 2})
    const assignedPermissions = useAppSelector((state: RootState) => state.application.permissions)
    const verifyPermission = (checkPermissions: string[]) => hasPermission(checkPermissions, assignedPermissions)

    const customHr = <hr className="mt-1 mb-1" />

    const editDvsaFee = (dvsaCard: any) => {
        dispatch(dvsaToggleAddEditModal(true))
        dispatch(setSelectedDvsaFee(dvsaCard.dealerName))
        dispatch(setDsvaFeeSelectedId(dvsaCard.dealerID))
    }

    return (
        <MDBCardBody className={`p-3 ${!dvsaCard.active ? "k-disabled" : ""}`}>
            <div className=" align-items-center mb-1">
                <div
                    title={dvsaCard.dealerName }
                    className="ps-0 mb-0 me-1 clip-text font-weight-bold text-muted text-overflow-wrap"
                >
                    {dvsaCard.dealerName ? dvsaCard.dealerName : <>&nbsp;</>}
                </div>
            </div>
            {customHr}
            <div>
                <div className="pt-2 mb-1 p-1">
                    <div className="d-flex justify-content-between ps-3 pe-3">
                        <div className="pe-1">Today</div>
                        <div className="font-weight-bold text-muted ps-0">
                            {dvsaCard.dvsaFee ? formatPrice(dvsaCard.dvsaFee) : <>&nbsp;</>}
                        </div>
                    </div>
                    <div className="d-flex justify-content-between pt-2 ps-3 pe-3">
                        <div>
                            {dvsaCard.effectiveDate1 ? (
                                dayjs(dvsaCard.effectiveDate1).format("DD/MM/YYYY")
                            ) : (
                                <>&nbsp;</>
                            )}
                        </div>
                        <div>{dvsaCard.dayFee1 ? formatPrice(dvsaCard.dayFee1) : <>&nbsp;</>}</div>
                    </div>
                    <div className="d-flex justify-content-between pt-2 ps-3 pe-3">
                        <div>
                            {dvsaCard.effectiveDate2 ? (
                                dayjs(dvsaCard.effectiveDate2).format("DD/MM/YYYY")
                            ) : (
                                <>&nbsp;</>
                            )}
                        </div>
                        <div>{dvsaCard.dayFee2 ? formatPrice(dvsaCard.dayFee2) : <>&nbsp;</>}</div>
                    </div>

                    <div className="d-flex justify-content-between pt-2 ps-3 pe-3">
                        <div>
                            {dvsaCard.effectiveDate3 ? (
                                dayjs(dvsaCard.effectiveDate3).format("DD/MM/YYYY")
                            ) : (
                                <>&nbsp;</>
                            )}
                        </div>
                        <div>{dvsaCard.dayFee3 ? formatPrice(dvsaCard.dayFee3) : <>&nbsp;</>}</div>
                    </div>

                    <div className="d-flex justify-content-between pt-2 ps-3 pe-3">
                        <div>
                            {dvsaCard.effectiveDate4 ? (
                                dayjs(dvsaCard.effectiveDate4).format("DD/MM/YYYY")
                            ) : (
                                <>&nbsp;</>
                            )}
                        </div>
                        <div>{dvsaCard.dayFee4 ? formatPrice(dvsaCard.dayFee4) : <>&nbsp;</>}</div>
                    </div>
                    <div className=" d-flex justify-content-between pt-2 ps-3 pe-3">
                        <div>
                            {dvsaCard.effectiveDate5 ? (
                                dayjs(dvsaCard.effectiveDate5).format("DD/MM/YYYY")
                            ) : (
                                <>&nbsp;</>
                            )}
                        </div>
                        <div>{dvsaCard.dayFee5 ? formatPrice(dvsaCard.dayFee5) : <>&nbsp;</>}</div>
                    </div>
                    <div className="d-flex justify-content-between pt-2 ps-3 pe-3">
                        <div>
                            {dvsaCard.effectiveDate6 ? (
                                dayjs(dvsaCard.effectiveDate6).format("DD/MM/YYYY")
                            ) : (
                                <>&nbsp;</>
                            )}
                        </div>
                        <div className="text-align-right">
                            {dvsaCard.dayFee6 ? formatPrice(dvsaCard.dayFee6) : <>&nbsp;</>}
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end pt-2 pb-2">
                <Button
                    fillMode="flat"
                    themeColor={"primary"}
                    size="small"
                    style={{
                        cursor: "pointer",
                        lineHeight: "1rem",
                        padding: "4px 12px",
                    }}
                    disabled={!dvsaCard.active}
                    onClick={(e: any) => editDvsaFee(dvsaCard)}
                >
                    {verifyPermission(["DVSAFee.Add"]) ? "Edit" : "View"}
                </Button>
            </div>
            {customHr}

            <MDBRow className="align-items-center ms-1 mt-1">
                <MDBCol className="ps-2">
                    <div>
                        <MDBRow className="pt-1">
                            <div className="ps-0 d-flex justify-content-start">
                                <div className="text-muted me-2">Last updated </div>
                                <div>
                                    {dvsaCard.updateDate ? (
                                        dayjs(dvsaCard.updateDate).format("DD/MM/YYYY HH:mm")
                                    ) : (
                                        <>&nbsp;</>
                                    )}
                                </div>
                            </div>
                        </MDBRow>
                        <MDBRow className="pt-1 pb-1">
                            <div className="ps-0 d-flex justify-content-start">
                                <div className="text-muted">
                                    By<>&nbsp;</>
                                </div>
                                <div className="text-overflow-wrap" title={dvsaCard.updateby}>
                                    {dvsaCard.updateby ? dvsaCard.updateby : <>&nbsp;</>}
                                </div>
                            </div>
                        </MDBRow>
                    </div>
                </MDBCol>
            </MDBRow>
        </MDBCardBody>
    )
}

export default DvsaFeePricingBody
